import img1 from "../assets/images/Group44.png"
import logo from "../assets/images/logo.png"
import sac from "../assets/images/Frame1.png"
import fleche from "../assets/images/chevron.png"
import plat1 from "../assets/images/plat1.png"
import plat2 from "../assets/images/plat2.png"
import plat3 from "../assets/images/plat3.png"


// const images = [img1, img2, img3, img4, img5, img6];

// export default images;
export const foodImages = {imageCircle: img1, logo, sac, chevronDown: fleche}

export const plats = [plat1, plat2, plat3 ]

